export const getWebStorageItem = <T extends string>(
  key: string,
  storage = window.localStorage
): T | null => {
  try {
    return storage.getItem(key) as T | null;
  } catch {
    return null;
  }
};

export const setWebStorageItem = (
  key: string,
  value: string,
  storage = window.localStorage
) => {
  try {
    storage.setItem(key, value);
    // eslint-disable-next-line no-empty
  } catch {}
};

export const removeWebStorageItem = (
  key: string,
  storage = window.localStorage
) => {
  try {
    storage.removeItem(key);
    // eslint-disable-next-line no-empty
  } catch {}
};

export const getWebStorage = (storage = window.localStorage) => {
  return {
    getItem: <T extends string>(key: string) => {
      return getWebStorageItem<T>(key, storage);
    },
    removeItem: (key: string) => {
      return removeWebStorageItem(key, storage);
    },
    setItem: (key: string, value: string) => {
      return setWebStorageItem(key, value, storage);
    },
  };
};
